import { Controller, UseFormReturn } from "react-hook-form";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";

import dayjs from "dayjs";

type Props<T extends {}> = {
  name: keyof T;
  label: string;
  required?: boolean;
  readOnly?: boolean;
  reactHookForm: UseFormReturn<T>;
};

/**
 * Retorna um array com dois Date | null.
 * Exemplo de Criação de parametro no HookForms:
 *  DATA: z.array(z.union([z.date(), z.null()])).length(2)
 */

export const FormRangeDatePickerInput = <T extends {}>({
  name,
  label,
  required,
  readOnly,
  reactHookForm,
}: Props<T>) => {
  return (
    <Controller
      name={name as any}
      control={reactHookForm.control}
      render={({ field, formState }) => {
        let helperText: string | null = null;
        const errors = formState.errors as any;

        if (errors[name]?.message) {
          helperText = errors[name].message as string;
        }

        return (
          <DateRangePicker
            value={
              Array.isArray(field.value)
                ? [
                  field.value[0] ? dayjs.utc(field.value[0]).local() : null,
                  field.value[1] ? dayjs.utc(field.value[1]).local() : null,
                ] : [
                  null,
                  null,
                ]
            }
            onChange={(newValue) => {
              if (newValue.every(value => value === null || value.isValid())) {
                field.onChange(newValue.map(value => value?.toDate() ?? null));
              }
            }}
            readOnly={readOnly}
            slotProps={{
              field: {
                clearable: true,
                onClear: () => field.onChange?.([null, null]),
              },
              textField: {
                label,
                size: "small",
                fullWidth: true,
                required,
                error: !!helperText,
                helperText,
                disabled: formState.disabled,
              },
            }}
          />
        );
      }}
    />
  );
};
